import req from 'utils/req';

export default {
  getCurrencies: () =>
    req(`${URL_API_HOST}/api/v1/finance/currency/rates`).get(),
};
